(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("HConfirmModalController", HConfirmModalController);

    HConfirmModalController.$inject = ['$scope', 'modalData', 'onHide', 'onAction'];

    function HConfirmModalController($scope, modalData, onHide, onAction) {

        var self = this;

        self.data = modalData;
        var confirmed = false;

        var doCallback = function () {
            setTimeout(function () {
                onAction(confirmed);
            }, 1);

            $scope.$hide();
        };

        self.confirm = function () {
            confirmed = true;
            doCallback();
        };

        self.close = function () {
            confirmed = false;
            doCallback();
        };

        $('.h-confirm-modal')
            .off("hide.bs.modal")
            .on("hide.bs.modal", onHide);
    }
})();